import React from 'react'
// export function SetCookie(name,value,days,min) {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days*24*60*60*1000));
//         expires = "; expires=" + date.toUTCString();
    
//     }
//     // else{
//     //     var date = new Date();
//     //     date.setTime(date.getTime() + (min*60*1000));
//     //     expires = "; expires=" + date.toUTCString();  
//     // }
//     document.cookie = name + "=" + (value || "")  + expires + "; path=/";
// }

export function SetCookie(name, value, days, min) {
    let url= window.location.origin
    // console.log(url)
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  } else if (min) {
    const date = new Date();
    date.setTime(date.getTime() + min * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  // نکته مهم: domain رو به .membersgram.com ست می‌کنیم که بین دامنه و ساب‌دامین مشترک باشه
 url === 'http://localhost:3000' ? 
   document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; path=/" +
    // "; domain=.membersgram.com" + // ← این خط مهمه
    "; secure" // اختیاری، اما برای HTTPS بهتره
 :  
  document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; path=/" +
    "; domain=.membersgram.com" + // ← این خط مهمه
    "; secure"; // اختیاری، اما برای HTTPS بهتره
}